import { render } from "./SidebarShortPanel.vue?vue&type=template&id=0fdce453&scoped=true&ts=true&lang=pug"
import script from "./SidebarShortPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarShortPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarShortPanel.vue?vue&type=style&index=0&id=0fdce453&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdce453"]])

export default __exports__